// extracted by css-extract-rspack-plugin
export default {"paper":"left-area-visible-filters-popover_paper__HVoYv","checkboxs":"left-area-visible-filters-popover_checkboxs__RrgYY"};